

const resetScrollAfterModalClose = () =>{
    if(document.querySelector('.modal')){
        jQuery('.modal').on('show.bs.modal', function(ev){
            let modal = ev.target;
            modal.setAttribute('data-scroll-y', window.scrollY);

        })
        jQuery('.modal').on('hidden.bs.modal', function(ev){
            let modal = ev.target;
            let scrollTo = modal.getAttribute('data-scroll-y');
            let hasHash = modal.getAttribute('data-has-hash');
            if(hasHash !== 'true'){
                window.scrollTo({top: scrollTo*1, left: 0, behavior: "instant"});
            }
            if(hasHash === 'true'){
                let theHash = modal.getAttribute('data-hash');
                let targetEl = document.querySelector(theHash);
                if(targetEl){
                    targetEl.scrollIntoView(
                        {
                            behavior: 'instant',
                        }
                    )
                }
            }
            modal.setAttribute('data-has-hash', '');


        })
    }
}
export default resetScrollAfterModalClose;